<dynamic-form
  *ngIf="columns && columns.length > 0 && formGroup"
  [apiName]="apiName"
  [areaName]="areaName"
  [label]="label"
  [group]="formGroup"
  [model]="model"
  [columns]="_Columns"
  [erroremessage]="erroremessage"
  (valueChange)="onChanged($event)"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content">
    <ssg-tabset (tabChange)="selectTab($event)">
      <ssg-tab
        [active]="isActveTab('ClientApp.GNR.PeopleInfo.Address.Address' | translate)"
        [tabTitle]="'ClientApp.GNR.PeopleInfo.Address.Address' | translate">
        <address-list
          *ngIf="isActveTab('ClientApp.GNR.PeopleInfo.Address.Address' | translate) === true && orignalColumns && orignalColumns.length > 0"
          [apiName]="apiName"
          [areaName]="areaName"
          [_columns]="orignalColumns"
          [(model)]="model">
        </address-list>
      </ssg-tab>
      <ssg-tab
        [active]="isActveTab('ClientApp.GNR.PeopleInfo.Telephone.Telephone' | translate)"
        [tabTitle]="'ClientApp.GNR.PeopleInfo.Telephone.Telephone' | translate">
        <telephone-list
          *ngIf="isActveTab('ClientApp.GNR.PeopleInfo.Telephone.Telephone' | translate) === true && orignalColumns && orignalColumns.length > 0"
          [apiName]="apiName"
          [areaName]="areaName"
          [(model)]="model"
          [_columns]="orignalColumns">
        </telephone-list>
      </ssg-tab>
      <ssg-tab
        [active]="isActveTab('ClientApp.GNR.PeopleInfo.Related.RelatedPersons' | translate)"
        [tabTitle]="'ClientApp.GNR.PeopleInfo.Related.RelatedPersons' | translate">
        <related-list
          *ngIf="isActveTab('ClientApp.GNR.PeopleInfo.Related.RelatedPersons' | translate) === true && orignalColumns && orignalColumns.length > 0"
          [apiName]="apiName"
          [areaName]="areaName"
          [(model)]="model"
          [_columns]="orignalColumns">
        </related-list>
      </ssg-tab>
    </ssg-tabset>
  </ng-container>
</dynamic-form>
